import { type ReactElement } from 'react';
import SolutionPageLayout from '../../components/features/SolutionPageLayout';

export default function KMU(): ReactElement {
  return (
    <SolutionPageLayout
      badge="Für KMU"
      title="Buchhaltung für den Mittelstand – professionell und effizient"
      subtitle="Als mittelständisches Unternehmen brauchen Sie mehr als nur Rechnungen schreiben. Saldify bietet alle Tools für professionelles Finanzmanagement."
      heroImage="/screenshots/app-buchhaltung.webp"
      heroImageAlt="Laufende Buchhaltung in Saldify mit Journal und Konten"
      introTitle="Professionelle Buchhaltung für Ihr Unternehmen"
      introText="Kleine und mittlere Unternehmen haben komplexere Anforderungen: Mehrere Mitarbeiter, verschiedene Kostenstellen, Zusammenarbeit mit dem Steuerberater. Saldify deckt all das ab."
      introBullets={[
        'Multi-User mit Rollen und Berechtigungen',
        'Kostenstellen und Projekte verwalten',
        'Nahtlose Steuerberater-Zusammenarbeit',
        'Umfassende Auswertungen und Reports',
      ]}
      benefits={[
        {
          title: 'Team-Verwaltung',
          description: 'Unbegrenzte Benutzer mit individuellen Rollen und Berechtigungen.',
        },
        {
          title: 'Kostenstellen',
          description: 'Ordnen Sie Ausgaben Projekten, Abteilungen oder Kunden zu.',
        },
        {
          title: 'Steuerberater-Zugang',
          description: 'Ihr Steuerberater hat direkten Zugriff auf alle relevanten Daten.',
        },
        {
          title: 'DATEV-Export',
          description: 'Nahtlose Integration mit DATEV und ADDISON.',
        },
        {
          title: 'Multi-Mandanten',
          description: 'Verwalten Sie mehrere Firmen in einem Account.',
        },
        {
          title: 'Dedizierter Support',
          description: 'Persönlicher Ansprechpartner und garantierte Reaktionszeiten.',
        },
      ]}
      useCases={[
        {
          title: 'Handelsunternehmen',
          description: 'Warenwirtschaft, Lieferantenmanagement und Bestandsführung.',
        },
        {
          title: 'Dienstleistungsunternehmen',
          description: 'Projektabrechnung, Zeiterfassung und Ressourcenplanung.',
        },
        {
          title: 'Produktionsunternehmen',
          description: 'Kostenrechnung, Kalkulation und Materialwirtschaft.',
        },
        {
          title: 'Holding-Strukturen',
          description: 'Multi-Mandanten, konsolidierte Auswertungen und Konzernstruktur.',
        },
      ]}
      features={[
        'Unbegrenzte Benutzer',
        'Multi-Mandanten-Fähigkeit',
        'Kostenstellen und Projektcontrolling',
        'Umfassende BWA und Kennzahlen',
        'DATEV- und ADDISON-Export',
        'API für ERP-Integration',
        'Audit-Log und Compliance',
        'SLA und dedizierter Support',
      ]}
      recommendedPlan={{
        name: 'Business',
        price: '49€/Monat',
        description: 'Für KMU: Unbegrenzte Benutzer, Multi-Mandanten, API-Zugang und dedizierter Support.',
      }}
      testimonial={{
        quote: 'Mit Saldify haben wir endlich den Überblick über alle drei Gesellschaften. Die Multi-Mandanten-Funktion ist Gold wert.',
        author: 'Michael B.',
        role: 'Geschäftsführer',
        company: 'Bauer Gruppe GmbH',
      }}
    />
  );
}
